<div class="change-password">
  <div class="container password-container">
    <div class="container-header no-bottom-border">
      <div class="text">Change Password</div>
    </div>
    <div class="container-content">
      <div class="container-row">
        <svg-icon src="assets/svg/lock-circle.svg"></svg-icon>
        <lhpe-input
          [formGroup]="changePasswordForm"
          controlName="currentPassword"
          class="input"
          type="password"
          placeholder="Current password"
          [required]="true"
        >
        </lhpe-input>
      </div>
      <div class="container-row">
        <svg-icon src="assets/svg/lock-circle.svg"></svg-icon>

        <lhpe-input
          [formGroup]="changePasswordForm"
          controlName="newPassword"
          class="input"
          type="password"
          placeholder="New password"
          [required]="true"
        >
        </lhpe-input>
      </div>

      <div class="container-row">
        <svg-icon src="assets/svg/lock-circle.svg"></svg-icon>

        <lhpe-input
          [formGroup]="changePasswordForm"
          controlName="confirmNewPassword"
          class="input"
          type="password"
          placeholder="Confirm new password"
          [required]="true"
        >
        </lhpe-input>
      </div>

      <div class="container-row submit-row">
        <button
          class="change-password-btn"
          mat-raised-button
          color="primary"
          [disabled]="changePasswordForm.invalid"
          (click)="changePassword()"
        >
          Change Password
        </button>
      </div>
    </div>
  </div>
</div>
